import React from 'react'
import { Link } from 'react-router-dom'

function WelcomeMessage() {

    return (
        <div className='welcome_pg'>
            {/* <div className="container"></div> */}
            <div className="wp_inner text-center">
                <h1 className="bold text_blue">Welcome to Work space</h1>
                <h6 className="text_black2">Simple and powerful way to manage and publish content on your displays.</h6>
                <Link to="/orgnisation-details">
                    <button className="primary_btn w-100">Next</button>
                </Link>
            </div>
        </div>
    )
}

export default WelcomeMessage
